import {
  List,
  Datagrid,
  TextField,
  DateField,
  EditButton,
  ShowButton,
  DeleteButton,
  ChipField,
} from 'react-admin';

export const TagList = () => (
  <List>
    <Datagrid>
      <TextField source="id" />
      <ChipField source="name" />
      <TextField source="slug" />
      <DateField source="createdAt" />
      <EditButton />
      <ShowButton />
      <DeleteButton mutationMode="pessimistic" />
    </Datagrid>
  </List>
);
